import React, { useEffect, useState, Children } from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'About',
    href: '#about'
  }, {
    name: 'Experience',
    href: '#experience'
  }, {
    name: 'Elections',
    href: '#elections'
  }, {
    name: 'Expertise',
    href: '#expertise'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: 'easeOut'
      }
    }
  };
  return <>
      {/* Sticky Navigation */}
      <motion.nav initial={{
      y: -100
    }} animate={{
      y: 0
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-zinc-950/80 backdrop-blur-md border-b border-zinc-800/50 py-4' : 'bg-transparent py-6'}`} data-id="element-161">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center" data-id="element-162">
          <a href="#" className="text-xl font-serif font-bold text-zinc-100 tracking-wide" data-id="element-163">
            Dinesh <span className="text-amber-500" data-id="element-164">Singh</span>
          </a>
          <div className="hidden md:flex space-x-8" data-id="element-165">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-zinc-400 hover:text-amber-500 transition-colors uppercase tracking-wider" data-id="element-166">
                {link.name}
              </a>)}
          </div>
        </div>
      </motion.nav>

      <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-32 pb-16 px-4 sm:px-6 lg:px-8" data-id="element-167">
        {/* Background subtle gradient */}
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-zinc-900/50 via-zinc-950 to-zinc-950 -z-10" data-id="element-168"></div>

        {/* Decorative background elements */}
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-amber-500/5 rounded-full blur-3xl -z-10" data-id="element-169"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-amber-500/5 rounded-full blur-3xl -z-10" data-id="element-170"></div>

        <motion.div className="max-w-5xl mx-auto flex flex-col items-center text-center z-10" variants={containerVariants} initial="hidden" animate="visible" data-id="element-171">
          <motion.div variants={itemVariants} className="relative mb-12 group" data-id="element-172">
            <div className="absolute inset-0 rounded-full bg-amber-500/20 blur-2xl transition-all duration-700 group-hover:bg-amber-500/30 group-hover:blur-3xl" data-id="element-173"></div>
            <div className="relative p-2 rounded-full bg-gradient-to-br from-amber-400 via-amber-600 to-amber-800" data-id="element-174">
              <div className="p-1 rounded-full bg-zinc-950" data-id="element-175">
                <img src="https://cdn.magicpatterns.com/uploads/pwiZqofbDPVALhiu5PKTAK/WhatsApp_Image_2026-04-28_at_11.59.47_PM.jpg" alt="Dinesh Singh" className="w-56 h-56 sm:w-64 sm:h-64 object-cover rounded-full border-4 border-zinc-900 shadow-2xl" data-id="element-176" />
              </div>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="mb-8" data-id="element-177">
            <h1 className="text-5xl sm:text-6xl md:text-8xl font-bold tracking-tight mb-4 text-zinc-100 drop-shadow-lg" data-id="element-178">
              Dinesh{' '}
              <span className="text-amber-500 italic font-light" data-id="element-179">Singh</span>
            </h1>
            <p className="text-2xl sm:text-3xl text-zinc-300 font-serif mb-2 max-w-3xl mx-auto leading-snug" data-id="element-180">
              Manager - Content, Chief Minister's Media Cell
            </p>
            <p className="text-lg sm:text-xl text-amber-500/80 font-serif italic mb-8 tracking-wide" data-id="element-181">
              Government of Uttar Pradesh
            </p>

            <div className="flex flex-wrap justify-center gap-4 text-xs sm:text-sm font-medium tracking-widest uppercase text-zinc-400 mb-10" data-id="element-182">
              <span className="px-4 py-2 rounded-full border border-zinc-800 bg-zinc-900/50 backdrop-blur-sm" data-id="element-183">
                Seasoned Media Professional
              </span>
              <span className="px-4 py-2 rounded-full border border-zinc-800 bg-zinc-900/50 backdrop-blur-sm" data-id="element-184">
                Content Strategist
              </span>
              <span className="px-4 py-2 rounded-full border border-zinc-800 bg-zinc-900/50 backdrop-blur-sm" data-id="element-185">
                Narrative Architect
              </span>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="flex flex-wrap justify-center gap-6 sm:gap-10" data-id="element-186">
            <div className="flex flex-col items-center" data-id="element-187">
              <span className="text-3xl font-serif font-bold text-amber-500" data-id="element-188">
                21+
              </span>
              <span className="text-xs uppercase tracking-widest text-zinc-500 mt-1" data-id="element-189">
                Years Experience
              </span>
            </div>
            <div className="w-px h-12 bg-zinc-800" data-id="element-190"></div>
            <div className="flex flex-col items-center" data-id="element-191">
              <span className="text-3xl font-serif font-bold text-amber-500" data-id="element-192">
                10
              </span>
              <span className="text-xs uppercase tracking-widest text-zinc-500 mt-1" data-id="element-193">
                Elections Covered
              </span>
            </div>
            <div className="w-px h-12 bg-zinc-800" data-id="element-194"></div>
            <div className="flex flex-col items-center" data-id="element-195">
              <span className="text-3xl font-serif font-bold text-amber-500" data-id="element-196">
                7
              </span>
              <span className="text-xs uppercase tracking-widest text-zinc-500 mt-1" data-id="element-197">
                Years CM Media Cell
              </span>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 1,
          delay: 2
        }} className="absolute bottom-10 left-1/2 -translate-x-1/2" data-id="element-198">
            <div className="w-[1px] h-24 bg-gradient-to-b from-amber-500/0 via-amber-500/50 to-amber-500/0 animate-pulse" data-id="element-199"></div>
          </motion.div>
        </motion.div>
      </section>
    </>;
}